import { createReducer } from "@reduxjs/toolkit";

let istate = {idk: "", uname: "", email: ""};

export default createReducer(istate,(builder)=>{
    builder.addCase('update_idk', (state,action)=>{
        state.idk = action.payload;
    })
    builder.addCase('update_uname',(state,action)=>{
        state.uname = action.payload;
    })
    builder.addCase('update_eml', (state, action )=>{
        state.email = action.payload;
    })
})